import React, { forwardRef } from 'react';

const baseClasses =
  'w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all';

const Input = forwardRef(({ leftIcon: LeftIcon, className = '', ...props }, ref) => {
  if (LeftIcon) {
    return (
      <div className="relative">
        <LeftIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          ref={ref}
          className={`${baseClasses} pl-10 ${className}`}
          {...props}
        />
      </div>
    );
  }

  return (
    <input
      ref={ref}
      className={`${baseClasses} ${className}`}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export default Input;
